import config from '../config';
var ApmService = /*@__PURE__*/ (function () {
    function ApmService() {
    }
    ApmService.post = function (data) {
        return new Promise(function (resolve, reject) {
            jQuery.ajax({
                type: 'post',
                url: config.appointman.api.BASE_URI + "/apm",
                data: JSON.stringify(data),
                success: function (res) {
                    resolve(res);
                },
                error: function (res, textStatus) {
                    reject(res, textStatus);
                }
            });
        });
    };
    ApmService.put = function (id, data) {
        return new Promise(function (resolve, reject) {
            jQuery.ajax({
                type: 'PUT',
                url: config.appointman.api.BASE_URI + "/apm/" + id,
                data: JSON.stringify(data),
                success: function (res) {
                    resolve(res);
                },
                error: function (res, textStatus) {
                    reject(res, textStatus);
                }
            });
        });
    };
    ApmService.cancel = function (id) {
        return new Promise(function (resolve, reject) {
            jQuery.ajax({
                type: 'POST',
                url: config.appointman.api.BASE_URI + "/apm/cancel",
                contentType: 'application/json',
                data: JSON.stringify({
                    apmid: id
                }),
                success: function (res) {
                    resolve(res);
                },
                error: function (res, textStatus) {
                    reject(res, textStatus);
                }
            });
        });
    };
    ApmService.get = function (apmID) {
        return new Promise(function (resolve, reject) {
            jQuery.ajax({
                url: config.appointman.api.BASE_URI + "/apm/" + apmID,
                success: function (res) {
                    resolve(res);
                },
                error: function (res, textStatus) {
                    reject(res, textStatus);
                }
            });
        });
    };
    return ApmService;
}());
export default ApmService;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/service/Apm.ts
// module id = null
// module chunks = 